import { parseJSON } from "./parseJSON";
import { getToken } from "../utils/authUtils";

const urlBase = `${process.env.API_URL}/motivo`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const fetchTreeMotivo = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl("tree"), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};
